var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3057 13V9C22.3057 4 20.3057 2 15.3057 2H9.30566C4.30566 2 2.30566 4 2.30566 9V15C2.30566 20 4.30566 22 9.30566 22H13.3057",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63574 14.49L10.0157 11.4C10.3557 10.96 10.9858 10.88 11.4258 11.22L13.2558 12.66C13.6958 13 14.3257 12.92 14.6657 12.49L16.9758 9.51001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7859 15.8199L20.0659 16.3899C20.2059 16.6699 20.5559 16.9299 20.8659 16.9899L21.2459 17.0499C22.3859 17.2399 22.6559 18.0799 21.8359 18.9099L21.4859 19.2599C21.2559 19.4999 21.1259 19.9599 21.1959 20.2799L21.2459 20.4899C21.5559 21.8699 20.8259 22.3999 19.6259 21.6799L19.3659 21.5299C19.0559 21.3499 18.5559 21.3499 18.2459 21.5299L17.9859 21.6799C16.7759 22.4099 16.0459 21.8699 16.3659 20.4899L16.4159 20.2799C16.4859 19.9599 16.3559 19.4999 16.1259 19.2599L15.7759 18.9099C14.9559 18.0799 15.2259 17.2399 16.3659 17.0499L16.7459 16.9899C17.0459 16.9399 17.4059 16.6699 17.5459 16.3899L17.8259 15.8199C18.3659 14.7299 19.2459 14.7299 19.7859 15.8199Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.eae8a54c73a0f209a4943a145c9fa3eb.svg";
export { ForwardRef as ReactComponent };